import { useIntl } from 'react-intl';
import { ThemeProvider } from 'styled-components';

import { Banner, Button, D2CTheme } from '@calm-web/design-system';

import { DiscountLandingProps } from '@/components/discountLanding/DiscountLandingWrapper/types';
import Image from '@/components/image/NextImage';
import GridWrapper from '@/components/ui/GridWrapper';
import { useFormattedCurrency } from '@/hooks/purchase';
import { useAppLoadedState, useDeviceState, usePricesState } from '@/hooks/store';
import errorMessages from '@/messages/errorMessages';
import StarsIcon from 'icons/five-stars-no-border.svg';

import investMessages from '../Invest/messages';
import { getActiveOffer } from '../utils/getActiveOffer';
import messages from './messages';
import {
	AppIcons,
	ButtonWrapper,
	Heading,
	RatingText,
	RatingWrapper,
	Users,
	WelcomeText,
	Wrapper,
} from './styles';

const Hero = ({ onClick, isDiscounted, welcomeText }: DiscountLandingProps) => {
	const { formatMessage } = useIntl();
	const appLoaded = useAppLoadedState();
	const formatCurrency = useFormattedCurrency();
	const offer = getActiveOffer(usePricesState(), useDeviceState());

	const getHeading = () => {
		if (offer?.type === 'firstMonth') {
			return formatMessage(messages.headingFirstMonth, { price: formatCurrency(offer.price) });
		}
		if (isDiscounted && offer?.type === 'percentOff') {
			return formatMessage(messages.heading, { percentOff: offer.percentOff });
		}
		return formatMessage(messages.headingWithoutDiscount);
	};
	const heading = getHeading();

	return (
		<>
			{!isDiscounted && appLoaded && (
				<ThemeProvider theme={D2CTheme}>
					<Banner backgroundColor="errorRed" textColor="white">
						{formatMessage(errorMessages.invalid_coupon)}
					</Banner>
				</ThemeProvider>
			)}
			<Wrapper>
				<GridWrapper columns={3}>
					{welcomeText && <WelcomeText color="gray8">{welcomeText}</WelcomeText>}
					<Heading>{heading}</Heading>
					<ButtonWrapper>
						<Button
							fullWidth
							backgroundColor="white"
							textColor="gray8"
							onPress={() =>
								onClick({
									section: 'hero',
									copy: messages.cta.defaultMessage,
								})
							}
						>
							{formatMessage(isDiscounted ? messages.cta : investMessages.cta)}
						</Button>
					</ButtonWrapper>
					<RatingWrapper>
						<Users>
							<Image width={96} height={48} src="/_n/images/discount-landing/user-ratings.webp" alt="" />
						</Users>
						<div>
							<StarsIcon />
							<RatingText>{formatMessage(messages.starRating)}</RatingText>
						</div>
					</RatingWrapper>
				</GridWrapper>
				<AppIcons>
					<Image
						fill
						style={{ objectFit: 'contain', objectPosition: 'bottom right' }}
						alt=""
						src="/_n/images/discount-landing/discount-app-icons.webp"
					/>
				</AppIcons>
			</Wrapper>
		</>
	);
};

export default Hero;
